import { receiptsApi } from '../api/receiptsApi'
import type { SendAnnualReportRequest } from '../api/receiptsApi'

export const sendAnnualReport = async ({
  memberId,
  year,
}: SendAnnualReportRequest) => {
  try {
    const response = await receiptsApi.sendAnnualReport({
      memberId,
      year,
    })
    return response.data
  } catch (error) {
    console.error(`Error sending annual report email: `, error)
    throw error
  }
}
